<template>
<div id="container" class="container zaubergeschichten">
  <div class="fullscreen_background">
    <img src="/static/assets/zaubergeschichten/Hintergrund_2860.jpg" />
  </div>

  <sterne :amount="100" :size="6" :speed="0.5" :wind="0" :opacity="1" :swing="1" :image="sternchen" :zIndex="null" :resize="true" color="#fff" />
  <top-logo />
  <stoppuhr />
  <lautsprecher />
  <top-menu />
  <copyright />
      <hintergrundbutton />

  <div class="miss_witch z30 dubix_animation">
    <!-- <img class="img" src="/static/assets/zaubergeschichten/Miss_witch.png" /> -->
  </div>
  <div class="professor_riese z30">
    <img class="img" src="/static/assets/zaubergeschichten/Professor_Riese.png" />
  </div>
  <!--div class="hui z30">
        <img class="img" src="/static/assets/zaubergeschichten/Hui.png" />
    </div-->
  <div class="gigi z30">
    <img class="img" src="/static/assets/zaubergeschichten/Gigi.png" />
  </div>
  <div class="globus z30">

  </div>
   <div class="kerze z30">

  </div>
  <div class="libero z30">
    <img class="img" src="/static/assets/zaubergeschichten/Libero.png" />
  </div>
  <div class="kugel z30">
    <img class="img hovering" src="/static/assets/zaubergeschichten/kugel.png" />
  </div>
  <!-- <div class="moebel_vorne z40">
        <img class="img" src="/static/assets/zaubergeschichten/Moebel_vorne.png" />
    </div> -->

  <!-- <router-link to="/maerchengeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
    </router-link> -->
  <!--div class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil-1.png" />
    </div-->

  <router-link to="/piratengeschichten" tag="div" class="pfeil_links_big z50 pointer">
    <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
  </router-link>
  <router-link tag="div" to="maerchengeschichten" class="pfeil_rechts_big z50 pointer">
    <img class="img" src="/static/assets/zaubergeschichten/Pfeil-1.png" />
  </router-link>

  <div class="geschichte z45">
    <div class="inner">
      <img src="/static/assets/zaubergeschichten/Geschichte.png" usemap="#geschichte-map">
      <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Zaubermeister_Dubix.mp3" jsonurl="/static/assets/geschichten/dubix.timings.json" content=".zaubergeschichten" target="zaubergeschichten_target" />
      <vuescrollbar tag="div" class="fliesstext" id="zaubergeschichten_target">
        <p>Die Hexenschüler Hui und Dubix saßen in der letzten Reihe ihres Klassenzimmers. Vorne sprach Professor Riese über magische Zahlen. Dubix gähnte. Nachher würde Miss Witch Zauberenglisch unterrichten und dann kam Großmagier Merlin. Er lehrte Verwandlungskunst
          und das fanden Dubix und Hui richtig cool. Es war das einzige Fach, in dem sie eine Eins hatten.</p>
        <p>Klassenbeste Gigi hingegen war in allen Fächern eine glänzende Schülerin. Hui und Dubix ging diese Besserzauberin ziemlich auf die Nerven. Deshalb hatten sie erst letzte Woche Gigis Stupsnase in eine dicke, fette Kartoffelnase verwandelt. Bätsch!
          Aber Ätsch! Schon am nächsten Tag wuchsen jedem der beiden große Eselsohren! Gigi zauberte die Ohren erst wieder weg, als Hui und Dubix ihr eine große Portion Spaghettieis spendierten.</p>
        <p>Auch für heute hatten sie sich einen super Streich ausgedacht. Tagelang hatten sie dafür Zauberbücher gewälzt. Sie wollten Gigi am Nachmittag in der Bibliothek die fertigen Hausaufgaben klauen, sie abschreiben und dann mit einem Verschwindezauber
          belegen. Schwuppdiwupp! Schon hätte die Klassenbeste am nächsten Tag keine Hausaufgaben vorlegen können! </p>
        <p>Doch als die beiden am Nachmittag in die Bibliothek kamen, war sie gähnend leer. Auf Gigis Platz lag aufgeschlagen ein altes, großes Zauberbuch. Dubix sah hinein. „Uii, Besserzauberin Gigi übt ebenfalls Verschwindezauber! Aber wo ist sie?“ „Wie
          vom Erdboden verschluckt“, erwiderte Hui. Die beiden sahen sich an. Potzblitz! Schlagartig wurde ihnen klar, was passiert war. Gigi hatte einen Verschwindezauber probiert, der Menschen vom Erdboden verschwinden lässt! Und nun hatte der Zauber
          nicht nur an der Bibliothekarin Madame Monokel gewirkt, die Gigi schnell wieder zurückgezaubert hätte, sondern auch an Gigi selbst! Ohje, jetzt waren beide vom Erdboden verschluckt!</p>
        <p>Hui und Dubix ließen durch ihre Köpfe rattern, was sie über Verschwindezauber gelesen hatten: „Zaubert sich ein Zauberer selbst in den Erdboden, braucht man für den Gegenzauber etwas aus dem Erdboden. Etwas, was auch durch magische Kräfte dorthin
          gekommen ist“, erinnerte sich Hui. „Hexchen Libero!“, rief Dubix. „Gigi lässt für ihren Hund doch immer Knochen im Gartenboden verschwinden!“ Dubix und Hui rannten zu ihren Besen und flogen so schnell sie konnten in Gigis Garten. </p>
        <p>Dort begrüßte sie kläffend Hexchen Libero. „Pssst, Hexchen Libero, du musst Gigi helfen! Such, such einen Knochen!“ Libero spürte, dass er den Jungs, die seine Gigi immer ärgerten, gehorchen musste, und begann eifrig, unter einem Apfelbaum zu
          graben. Als er stolz einen Knochen zwischen seinen Zähnen hielt, nahm Dubix seinen Zauberstab, legte ihn auf den Knochen und sprach: „Jetzt weich aus dem Erdreich! Hex, Hugidubie, große Magie!“ Hui nahm Libero auf seinen Arm, die drei schwangen
          sich auf die Besen und flogen flugs zurück zur Bibliothek. Hurra! Dort saßen Madame Monokel und Gigi, als wäre nichts passiert. Libero begrüßte Gigi überschwänglich. Gigi streichelte ihren kleinen Liebling und hob den Kopf: „Danke, dass ihr
          uns da unten rausgeholt habt. Du bist ein echter Zaubermeister, Dubix!“ Von nun an zauberten sie gemeinsam und spielten ihren Lehrern lustige Streiche. Manchmal stritten sie sich auch. In einem aber waren sie sich immer einig:</p>
        <p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
  </div>

</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
/* eslint whitespace: "off" */
/* eslint indent: "off" */
/* eslint keyword-spacing: "off" */
/* eslint no-unused-vars: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Copyright from '@/components/Copyright.vue'
import Snowf from 'vue-snowf'
import Lautsprecher from '@/components/Lautsprecher.vue'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Zaubergeschichten',
  data () {
    return {
      who: 'Zaubergeschichten',
      sternchen: '/static/assets/zaubergeschichten/sternchen.png',
      audioposition: 0
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'sterne': Snowf,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  mounted () {
    this.$ga.page(this.$router)
    var self = this
    setTimeout(function () {
      var muted = (typeof self.$root.muted !== 'undefined' ? self.$root.muted : false)
      try {
        window.currentAudioX.pause()
        window.currentAudioX.currentTime = 0
        window.currentAudioX = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      try {
        window.currentAudio.pause()
        window.currentAudio.currentTime = 0
        window.currentAudio = null
      } catch (e) {
            console.log('pause geht nicht')
      }
      window.currentAudioX = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Dubix_Titel.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }

      window.hintergrundSound = new Audio ('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Zauberer_Atmo.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined'?   window.muted : false)
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e) {
        window.bgsounddisabled = true
      }


    }, 1000);
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
      console.log('hintergrundsound nicht aktiv')
    }

  }
}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

/* Z-Index - Level */

.z1 {
  z-index: 10;
}

.z2 {
  z-index: 20;
}

.z3 {
  z-index: 30;
}

.z4 {
  z-index: 40;
}

.z5 {
  z-index: 50;
}

.z6 {
  z-index: 60;
}

.z7 {
  z-index: 70;
}

.z8 {
  z-index: 80;
}

.z9 {
  z-index: 90;
}

.z10 {
  z-index: 100;
}

.z11 {
  z-index: 110;
}

.z12 {
  z-index: 120;
}

.z13 {
  z-index: 130;
}

.z14 {
  z-index: 140;
}

.z15 {
  z-index: 150;
}

.z16 {
  z-index: 160;
}

.z17 {
  z-index: 170;
}

.z18 {
  z-index: 180;
}

.z19 {
  z-index: 190;
}

.z20 {
  z-index: 200;
}

.z21 {
  z-index: 210;
}

.z22 {
  z-index: 220;
}

.z23 {
  z-index: 230;
}

.z24 {
  z-index: 240;
}

.z25 {
  z-index: 250;
}

.z26 {
  z-index: 260;
}

.z27 {
  z-index: 270;
}

.z28 {
  z-index: 280;
}

.z29 {
  z-index: 290;
}

.z30 {
  z-index: 300;
}

.z31 {
  z-index: 310;
}

.z32 {
  z-index: 320;
}

.z33 {
  z-index: 330;
}

.z34 {
  z-index: 340;
}

.z35 {
  z-index: 350;
}

.z36 {
  z-index: 360;
}

.z37 {
  z-index: 370;
}

.z38 {
  z-index: 380;
}

.z39 {
  z-index: 390;
}

.z40 {
  z-index: 400;
}

.z41 {
  z-index: 410;
}

.z42 {
  z-index: 420;
}

.z43 {
  z-index: 430;
}

.z44 {
  z-index: 440;
}

.z45 {
  z-index: 450;
}

.z46 {
  z-index: 460;
}

.z47 {
  z-index: 470;
}

.z48 {
  z-index: 480;
}

.z49 {
  z-index: 490;
}

.z50 {
  z-index: 500;
}

/* zaubergeschichten */

.zaubergeschichten {
  position: absolute;
  width: 1920px;
  height: 1080px;
  top: 0;
}

.zaubergeschichten .himmel {
  display: block !important;
}

.zaubergeschichten .geschichte {
  position: absolute;
  top: 170px;
  left: 51%;
}

.zaubergeschichten .geschichte .inner {
  position: relative;
}



.zaubergeschichten .pfeil_links_big {
  position: absolute;
  left: 1vw;
  top: 40%;
}

.zaubergeschichten .pfeil_rechts_big {
  position: absolute;
  right: 1vw;
  top: 40%;
}

.zaubergeschichten .moebel_vorne {
  position: absolute;
  bottom: 0;
  left: 0;
}

.zaubergeschichten .miss_witch {
  position: absolute;
  /* top: 50%; left: 21%; */
  top: 47%;
  left: 23%;
}

.zaubergeschichten .professor_riese {
  position: absolute;
  top: 58%;
  right: 3%;
  opacity:0;
  animation: riese_erscheint 1s;
  animation-fill-mode: forwards;
  animation-delay: 0.75s;
}

@keyframes riese_erscheint {
  /* 0% {
    right: -3%;
    opacity: 0;
  }
  100% {
    right: 3%;
    opacity: 1;
  } */
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.zaubergeschichten .libero {
  position: absolute;
  top: 39%;
  right: 5.3%;
}

.zaubergeschichten .libero {
  animation: libero_erscheint 0.5s ease-out;
  animation-delay: 0.5s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
}

@keyframes libero_erscheint {
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.zaubergeschichten .gigi {
  position: absolute;
  top: 39%;
  left: 33%;
}

.zaubergeschichten .gigi img {
  animation-delay: 8s;
  animation: gigi_erscheint 1s;
  transform-origin: bottom center;
}

@keyframes gigi_erscheint {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(0.5);
    opacity: 0;
  }
  80% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.zaubergeschichten .fliesstext {
  bottom: 28%;
  left: 9.5%;
  width: 79%;
  font-size: 16pt;
  font-family: 'Open Sans';
  font-weight: 400;
  position: absolute;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 450px;
  padding-right: 15px;
}

.zaubergeschichten div.fliesstext>span {
  margin-right: 8px !important;
  float: left !important;
}

::-webkit-scrollbar {
  width: 15px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 0px #ac8a69;
  box-shadow: inset 0 0 0px #ac8a69;
  -webkit-border-radius: 0;
  border-radius: 0;
}

::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: #ac8a69;
}

::-webkit-scrollbar-thumb:window-inactive {
  background: #ac8a69;
}

::-webkit-scrollbar-button {
  background: none;
}

::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat;
}

::-webkit-scrollbar-button:vertical:decrement {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_up.png);
  background-position: 0px 0px;
}

::-webkit-scrollbar-button:vertical:increment {
  background-image: url(http://www.fruehling.eu/wp-content/uploads/2018/02/arrow_do.png);
  background-position: 0px 0px;
}

.snowf-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 150% !important;
  height: 150% !important;
  left: -25% !important;
  z-index: 30 !important;
}

.dubix_animation {
  width: 320px;
  height: 320px;
  background: url('/static/assets/zaubergeschichten/01_Zaubermeister_Dubix.png') top center;
  animation-delay: 2s;
  animation: play_dubix 4s steps(5) infinite;
  transform: scale(1);
  margin-top: -25px;
  margin-left: -50px;
}

@keyframes play_dubix {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -1600px;
  }
  100% {
    background-position: 0 -1600px;
  }
}

.globus {
  width: 350px;
  height: 350px;
  background: url('/static/assets/zaubergeschichten/01_Globus_1.png') top center;
  animation-delay: 2s;
  animation: play_globus 4s steps(6) infinite;
  transform: scale(0.465);
  top: -87px;
  left: 849px;
  position: absolute;
}

@keyframes play_globus {
  0% {
    background-position: 0 0px;
  }
  50% {
    background-position: 0 -2100px;
  }
  100% {
    background-position: 0 -2100px;
  }
}
.kerze {
    width: 380px;
    height: 529px;
    background: url(/static/assets/zaubergeschichten/01_Kerze_1.png) top center;
    animation: play_kerze 2s steps(8) infinite;
    transform: scale(0.26);
    top: 533px;
    left: 728px;
    position: absolute;
}

@keyframes play_kerze {
  0% {
    background-position: 0 0px;
  }
  100% {
    background-position: 0 -4232px;
  }
}
.kugel.z30 {
  position: absolute;
  top: 420px;
  left: 350px;
}

.kugel {
  animation: hexe_erscheint 10s linear;
  animation-delay: 0.75s;
  animation-fill-mode: forwards;
  opacity: 0;
  transform-origin: bottom center;
  margin-top: -800px;
}

@keyframes hexe_erscheint {
  0% {
    margin-top: -500px;
    opacity: 0;
    margin-left: 40px;
  }
  25% {
    opacity: 1;
    margin-top: -400px;
    margin-left: -50px;
  }
  50% {
    opacity: 1;
    margin-top: -300px;
    margin-left: 60px;
  }
  50% {
    opacity: 1;
    margin-top: -200px;
    margin-left: -30px;
  }
  75% {
    opacity: 1;
    margin-top: -100px;
    margin-left: 20px;
  }
  100% {
    margin-left: 0px;
    opacity: 1;
    margin-top: 0px;
  }
}

.hovering {
  -webkit-animation: hovering 8s ease-in-out infinite;
  -moz-animation: hovering 8s ease-in-out infinite;
  -ms-animation: hovering 8s ease-in-out infinite;
  -o-animation: hovering 8s ease-in-out infinite;
  animation: hovering 8s ease-in-out infinite;
}

@-webkit-keyframes hovering
/* Safari and Chrome */

  {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

@keyframes hovering {
  0% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
  /* 25% {
    -ms-transform: translate(-20px,20px);
    -moz-transform: translate(-20px,20px);
    -webkit-transform: translate(-20px,20px);
    -o-transform: translate(-20px,20px);
    transform: translate(-20px,20px);
  }
 */
  50% {
    -ms-transform: translate(0px, 20px);
    -moz-transform: translate(0px, 20px);
    -webkit-transform: translate(0px, 20px);
    -o-transform: translate(0px, 20px);
    transform: translate(0px, 20px);
  }
  /*  75% {

    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
*/
  100% {
    -ms-transform: translate(0, 0);
    -moz-transform: translate(0, 0);
    -webkit-transform: translate(0, 0);
    -o-transform: translate(0, 0);
    transform: translate(0, 0);
  }
}

span {
  font-family: FrozenMemory;
}
</style>



// WEBPACK FOOTER //
// src/components/Zaubergeschichten.vue